// extracted by mini-css-extract-plugin
export default {"departments":"VJ-z","departmentHeading":"WJ-z","departmentSection":"XJ-z","departmentName":"YJ-z","departmentLink":"ZJ-z","expandIcon":"_J-z"};